module.exports = {
	"RETRY_DELAY_IF_RATE_LIMITED": 5000
};


//////////////////
// WEBPACK FOOTER
// ./~/Airtable/lib/internal_config.json
// module id = 28
// module chunks = 1